import { ReferralProfileSettings } from "@/components/features/referrals/ReferralProfileSettings";
import { AppPageShell, GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/referrals/directory-profile")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.referralsSettings)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <AppPageShell>
      <ReferralProfileSettings />
    </AppPageShell>
  );
}
